import AudioBlock from './AudioBlock';

export default AudioBlock;
export * from './AudioBlock.type';
